import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getEurocoldProduct, getEurocoldProductDetail } from '../actions/MainAction'

import StartSvg from './svg/StartSvg'
import InstagramSvg from './svg/InstagramSvg'
import YoutubeSvg from './svg/YoutubeSvg'
import GoodSold from './GoodSold'
import ManatSvg from './svg/ManatSvg'
import { Link } from 'react-router-dom'

const SingleEuroColdProduct = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const allProducts = useSelector(state => state.Data.eurocoldProductData);

    const eurocoldProductDetailData = useSelector(state => state.Data.eurocoldProductDetailData);


    useEffect(() => {
        dispatch(getEurocoldProduct());
        dispatch(getEurocoldProductDetail());
    }, [dispatch]);


    const product = allProducts?.find(item => String(item.id) === id);

    const matchedDetails = eurocoldProductDetailData?.filter(
        (data) => String(data?.euro_cold_products) === id
    );

    if (!product) {
        return <div className='container py-[80px] text-center text-[20px]'>Məhsul tapılmadı və ya yüklənir...</div>
    }



    return (
        <main className='container'>
            <section>
                <div className='flex items-start gap-[32px] mt-[32px] max-[1000px]:flex-col max-[1000px]:items-center'>
                    <div className='w-1/2 h-auto rounded-[12px] flex items-center max-[1000px]:w-full'>
                        <div className='flex w-full flex-col'>
                            <img src={product?.image_full_url} className='w-full max-h-[500px] rounded-[8px]' />
                        </div>
                    </div>

                    <div className='flex flex-col w-1/2 gap-[12px] max-[1000px]:w-full'>
                        <div className='flex flex-col gap-[6px]'>
                            <h3 className='font-[500] text-[40px] leading-[55px] text-[#000]'>{product?.title}</h3>
                            <div className='flex items-start ml-[4px] gap-[4px]'>
                                <StartSvg /><StartSvg /><StartSvg /><StartSvg /><StartSvg />
                            </div>
                        </div>

                        <div className='font-[400] text-[18px] text-[#5E5E5E] leading-[27px] max-w-[530px]' dangerouslySetInnerHTML={{ __html: product?.description }} />

                        <div className='border-t-[1px] pt-[12px] gap-[10px] flex items-start w-full'>
                            <div className='flex items-center gap-[6px] border-l pl-[14px]'>
                                <ManatSvg width="28" height="25" />
                                <span className='text-[35px] font-[500]'>{product?.price}</span>
                            </div>

                            {product?.raiting === 1 && (
                                <div className='flex items-start'>
                                    <span className='text-[#F05127] font-[400] text-[16px] border-l pl-[7px]'>1metr'ə görə qiymət</span>
                                </div>
                            )}
                            {product?.raiting === 2 && (
                                <div className='flex items-start'>
                                    <span className='text-[#F05127] font-[400] text-[16px] border-l pl-[7px]'>1kub'a görə qiymət</span>
                                </div>
                            )}
                            {product?.raiting === 3 && (
                                <div className='flex items-start'>
                                    <span className='text-[#F05127] font-[400] text-[16px] border-l pl-[7px]'>1kv'a görə qiymət</span>
                                </div>
                            )}
                        </div>

                        <div className='border-t-[1px] border-b-[1px] flex items-center justify-between p-[24px_0px] max-[500px]:flex-col max-[500px]:items-start max-[500px]:gap-[12px]'>
                            <div className='border-l-[1px] pl-[12px]'>
                                <span className='font-[400] text-[15px] text-[#363636]'>Ən yeni alman texnologiyası</span>
                            </div>
                            <div className='border-l-[1px] pl-[12px]'>
                                <span className='font-[400] text-[15px] text-[#363636]'>Çatdırılma 3 - 15 gün</span>
                            </div>
                            <div className='border-l-[1px] pl-[12px]'>
                                <span className='font-[400] text-[15px] text-[#363636]'>1 il Rəsmi Zəmanət</span>
                            </div>
                        </div>

                        <div className='flex flex-col gap-[10px]'>
                            <h5 className='font-[450] text-[26px] text-[#363636] leading-[30px]'>Bizi izlə !</h5>
                            <span className='font-[400] text-[16px] leading-[19px] text-[#363636]'>
                                Sosial medialarda bizi izləyin, yeniliklərdən ilk siz xəbərdar olun.
                            </span>
                            <div className='flex items-center gap-[20px]'>
                                <Link to="https://www.instagram.com/aikcompany/" target='__blank'><InstagramSvg /></Link>
                                <Link to="https://youtube.com/@aikandcompany?si=DrlPa1KHj-h5u-lj" target='__blank'><YoutubeSvg /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='flex flex-col gap-[20px] mt-[32px]'>
                <div>
                    <h4 className='font-[450px] text-[22px] text-[#363636]'>Texniki Xüsusiyyətləri :</h4>
                </div>

                <div className='w-1/2 flex items-start max-[1000px]:w-full'>
                    <div className='grid grid-cols-2 gap-[42px] w-full max-[480px]:grid-cols-1'>
                        {matchedDetails
                            ?.map((data, i) => {
                                return (
                                    <span key={i} className='font-[450px] text-[16px] leading-[20px] text-[#363636]'>{data?.text}</span>
                                )
                            })
                        }
                    </div>
                </div>

            </section>
        </main>
    )
}

export default SingleEuroColdProduct
